import styled from "styled-components";

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  .header-text {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
`; 